import MicroModal from 'micromodal';
import jQuery from 'jquery';
import Barba from '@barba/core';
import 'jquery-ui/ui/widgets/slider'; // Import just the slider widget from jQuery UI
import 'slick-carousel'; // Import slick carousel

const CustomExp = {
  customExController: null,

  customExSlider: function () {
    // Check if needed elements exist
    if (!jQuery('.custom-exp-virtual-slider').length) {
      console.log('No custom experience slider found, skipping initialization');
      return;
    }

    console.log('Initializing customExSlider');

    let $customExCurrentStatus = jQuery('.current-slider'),
      $customExTotalStatus = jQuery('.total-slider'),
      $customExSliderControler,
      $customExSlider = jQuery('.custom-exp-virtual-slider'),
      slider,
      $customExTotalCount,
      $customExCurrentCount;

    try {
      // Get the total number of slides directly first
      const slideCount = jQuery('.custom-exp-virtual-slider .slider').length;
      console.log('Total slides found:', slideCount);

      // Set initial values for the counters
      if (slideCount > 0) {
        $customExCurrentStatus.text('1');
        $customExTotalStatus.text(slideCount);
        $customExTotalCount = slideCount;
        $customExCurrentCount = 1;
      }

      // Initialize jQuery UI Slider Controller element first
      if (jQuery('.custom-exp-virtual-slider-controller .progress-bar').length) {
        slider = jQuery('.custom-exp-virtual-slider-controller .progress-bar').slider({
          min: 0,
          max: 100,
          value: 0,
          animate: 'slow',
          step: 0.001,
          disabled: true,
        });
        console.log('Progress bar slider initialized');

        // Add debug info about progress bar
        const progressBarWidth = jQuery('.progress-bar').width();
        const handleWidth = jQuery('.ui-slider-handle').width();
        const handlePosition = jQuery('.ui-slider-handle').position();
        console.log('DEBUG - Initial state:', {
          'Progress bar width': progressBarWidth,
          'Handle width': handleWidth,
          'Handle position': handlePosition,
          'Handle left': jQuery('.ui-slider-handle').css('left'),
          'Handle margin-left': jQuery('.ui-slider-handle').css('margin-left'),
        });

        // Calculate the segment size based on number of slides
        const segmentWidth = (100 / slideCount).toFixed(4) + '%';

        // Set initial handle style matching the production site
        jQuery('.custom-exp-virtual-slider-controller .ui-slider-handle').css({
          width: segmentWidth,
          'margin-left': '-' + segmentWidth,
          left: segmentWidth, // Start at first segment
        });

        console.log('DEBUG - Segment width calculated:', segmentWidth);
      }

      // Initialize main slick slider
      if (!jQuery('.custom-exp-virtual-slider').hasClass('slick-initialized')) {
        jQuery('.custom-exp-virtual-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: false,
          draggable: false,
          asNavFor: '.custom-exp-virtual-slider-content',
          prevArrow: jQuery('.left-arrow svg'),
          nextArrow: jQuery('.right-arrow svg'),
          cssEase: 'ease-out',
          initialSlide: 0,
        });
        console.log('Main slider initialized');
      }

      // Initialize content slider
      if (!jQuery('.custom-exp-virtual-slider-content').hasClass('slick-initialized')) {
        jQuery('.custom-exp-virtual-slider-content').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: '.custom-exp-virtual-slider',
          draggable: false,
          dots: false,
          fade: true,
          focusOnSelect: true,
          cssEase: 'ease-out',
          initialSlide: 0,
        });
        console.log('Content slider initialized');
      }

      // Changes the current and total slider count
      jQuery('.custom-exp-virtual-slider').on(
        'init reInit afterChange',
        function (event, slick, currentSlide, nextSlide) {
          console.log(
            'Slider event:',
            event.type,
            'Current slide:',
            currentSlide,
            'Total slides:',
            slick.slideCount
          );

          // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          $customExCurrentStatus.text(i);
          $customExTotalStatus.text(slick.slideCount);
          $customExTotalCount = slick.slideCount;
          $customExCurrentCount = i;

          try {
            // Calculate segment width
            const segmentWidth = (100 / slick.slideCount).toFixed(4);

            // Calculate the position based on current slide (using production site approach)
            const position = i * segmentWidth + '%';

            // Set the slider handle position directly
            jQuery('.custom-exp-virtual-slider-controller .ui-slider-handle').css({
              width: segmentWidth + '%',
              'margin-left': '-' + segmentWidth + '%',
              left: position,
            });

            // Log updated values
            console.log('DEBUG - Set slider position:', {
              Slide: i,
              Total: slick.slideCount,
              'Segment Width': segmentWidth + '%',
              Position: position,
            });
          } catch (e) {
            console.error('Error updating progress bar slider position:', e);
          }
        }
      );

      // Force trigger the init event to update counters and slider position
      setTimeout(() => {
        if (jQuery('.custom-exp-virtual-slider').hasClass('slick-initialized')) {
          const slick = jQuery('.custom-exp-virtual-slider').slick('getSlick');
          console.log('Manually triggering slider init with slide count:', slick.slideCount);

          // Update the counters
          $customExCurrentStatus.text('1');
          $customExTotalStatus.text(slick.slideCount);
          $customExTotalCount = slick.slideCount;
          $customExCurrentCount = 1;

          // Calculate segment width
          const segmentWidth = (100 / slick.slideCount).toFixed(4);

          // Set the first position using production site approach
          jQuery('.custom-exp-virtual-slider-controller .ui-slider-handle').css({
            width: segmentWidth + '%',
            'margin-left': '-' + segmentWidth + '%',
            left: segmentWidth + '%', // First segment
          });

          console.log('DEBUG - Manual init:', {
            Slide: 1,
            Total: slick.slideCount,
            'Segment Width': segmentWidth + '%',
            Position: segmentWidth + '%',
          });
        }
      }, 100);

      // Stop autoplay when arrow is interacted
      jQuery('.left-arrow svg, .right-arrow svg').on('click', function () {
        jQuery('.custom-exp-virtual-slider')
          .slick('slickSetOption', 'autoplay', false)
          .slick('slickPause');

        // After navigation, update the slider handle position
        setTimeout(() => {
          const slick = jQuery('.custom-exp-virtual-slider').slick('getSlick');
          const currentSlide = slick.currentSlide;
          const totalSlides = slick.slideCount;

          // Calculate segment width
          const segmentWidth = (100 / totalSlides).toFixed(4);

          // Calculate the position based on current slide (using production site approach)
          const position = (currentSlide + 1) * segmentWidth + '%';

          // Set the slider handle position directly
          jQuery('.custom-exp-virtual-slider-controller .ui-slider-handle').css({
            width: segmentWidth + '%',
            'margin-left': '-' + segmentWidth + '%',
            left: position,
          });

          console.log('DEBUG - Arrow navigation:', {
            'Current slide': currentSlide + 1,
            'Total slides': totalSlides,
            'Segment Width': segmentWidth + '%',
            Position: position,
          });
        }, 50);
      });
    } catch (e) {
      console.error('Error initializing custom experience sliders:', e);
    }
  },

  customExMobile: function () {
    // Check if we're on mobile
    const isMobile =
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        navigator.userAgent.substr(0, 4)
      );

    if (isMobile) {
      console.log('Mobile device detected, making mobile adjustments');
      // Mobile specific adjustments could go here
    }
  },

  customExModal: function () {
    try {
      const openEl = document.querySelectorAll('.open-customExp');

      if (openEl && openEl.length > 0) {
        console.log('Initializing custom experience modal');
        MicroModal.init({
          disableScroll: true,
          closeTrigger: 'data-micromodal-close',
        });

        document.querySelectorAll('.open-customExp').forEach((item) => {
          item.addEventListener('click', (event) => {
            // Handle click
            event.preventDefault();
            MicroModal.show('customExp-modal');
          });
        });
      }
    } catch (e) {
      console.error('Error initializing custom experience modal:', e);
    }
  },

  weddingModal: function () {
    try {
      const openEl = document.querySelectorAll('.open-wedding');

      if (openEl && openEl.length > 0) {
        console.log('Initializing wedding modal');
        MicroModal.init({
          disableScroll: true,
          closeTrigger: 'data-micromodal-close',
        });

        document.querySelectorAll('.open-wedding').forEach((item) => {
          item.addEventListener('click', (event) => {
            // Handle click
            event.preventDefault();
            MicroModal.show('wedding-modal');
          });
        });
      }
    } catch (e) {
      console.error('Error initializing wedding modal:', e);
    }
  },

  initTrueTour: function () {
    // Check if the TrueTour popup script is loaded
    if (typeof window.TT8 !== 'undefined' && typeof window.TT8.initPopups === 'function') {
      console.log('Initializing TrueTour popups');
      window.TT8.initPopups();
    } else {
      console.log('TrueTour not available, will try again when script loads');
      // Add event listener for when the script loads
      window.addEventListener('load', function () {
        if (typeof window.TT8 !== 'undefined' && typeof window.TT8.initPopups === 'function') {
          console.log('TrueTour loaded, initializing popups');
          window.TT8.initPopups();
        }
      });
    }
  },

  init: function () {
    console.log('CustomExp.init called');

    // Initialize slider
    this.customExSlider();

    // Initialize other components
    this.customExMobile();
    this.weddingModal();
    this.customExModal();
    this.initTrueTour();
  },
};

// Setup Barba namespace with modern hooks
const venueHooks = {
  beforeEnter(data) {
    console.log('CustomExp: beforeEnter', data);

    // Clean up any existing slick sliders to prevent duplicates
    if (jQuery('.custom-exp-virtual-slider').hasClass('slick-initialized')) {
      try {
        jQuery('.custom-exp-virtual-slider').slick('unslick');
        console.log('Destroyed custom experience slider');
      } catch (e) {
        console.error('Error destroying custom experience slider:', e);
      }
    }

    if (jQuery('.custom-exp-virtual-slider-content').hasClass('slick-initialized')) {
      try {
        jQuery('.custom-exp-virtual-slider-content').slick('unslick');
        console.log('Destroyed custom experience content slider');
      } catch (e) {
        console.error('Error destroying custom experience content slider:', e);
      }
    }
  },

  enter(data) {
    console.log('CustomExp: enter', data);

    // Wait for DOM to be fully ready before initializing
    setTimeout(() => {
      CustomExp.init();
      console.log('CustomExp.init completed');
    }, 100);
  },

  afterEnter(data) {
    console.log('CustomExp: afterEnter', data);

    // Initialize gravity forms if available
    try {
      (function (SHFormLoader, Q) {
        Q.get('/wp-admin/admin-ajax.php?action=gf_button_get_form&form_id=1', function (response) {
          Q('#gf_button_form_container_1').html(response).fadeIn();

          if (window.gformInitDatepicker && typeof window.gformInitDatepicker === 'function') {
            window.gformInitDatepicker();
          }
        });
      })((window.SHFormLoader = window.SHFormLoader || {}), jQuery);
    } catch (e) {
      console.error('Error initializing gravity forms:', e);
    }

    // Reinitialize sliders after a short delay to ensure DOM is fully ready
    setTimeout(() => {
      if (
        jQuery('.custom-exp-virtual-slider').length &&
        !jQuery('.custom-exp-virtual-slider').hasClass('slick-initialized')
      ) {
        console.log('Reinitializing custom experience sliders');
        CustomExp.customExSlider();
      } else if (jQuery('.custom-exp-virtual-slider').hasClass('slick-initialized')) {
        // If slider is already initialized, manually update the counters
        const slick = jQuery('.custom-exp-virtual-slider').slick('getSlick');
        const currentSlide = slick.currentSlide || 0;
        jQuery('.current-slider').text(currentSlide + 1);
        jQuery('.total-slider').text(slick.slideCount);

        // Calculate segment width
        const segmentWidth = (100 / slick.slideCount).toFixed(4);

        // Calculate the position based on current slide (using production site approach)
        const position = (currentSlide + 1) * segmentWidth + '%';

        // Set the slider handle position directly
        jQuery('.custom-exp-virtual-slider-controller .ui-slider-handle').css({
          width: segmentWidth + '%',
          'margin-left': '-' + segmentWidth + '%',
          left: position,
        });

        console.log('DEBUG - afterEnter slider update:', {
          'Current slide': currentSlide + 1,
          'Total slides': slick.slideCount,
          'Segment Width': segmentWidth + '%',
          Position: position,
        });
      }
    }, 500);
  },

  leave(data) {
    console.log('CustomExp: leave', data);

    // Clean up any existing slick sliders before leaving
    if (jQuery('.custom-exp-virtual-slider').hasClass('slick-initialized')) {
      try {
        jQuery('.custom-exp-virtual-slider').slick('unslick');
        console.log('Destroyed custom experience slider during leave');
      } catch (e) {
        console.error('Error destroying custom experience slider during leave:', e);
      }
    }

    if (jQuery('.custom-exp-virtual-slider-content').hasClass('slick-initialized')) {
      try {
        jQuery('.custom-exp-virtual-slider-content').slick('unslick');
        console.log('Destroyed custom experience content slider during leave');
      } catch (e) {
        console.error('Error destroying custom experience content slider during leave:', e);
      }
    }
  },
};

// Make hooks available for Barba.js
CustomExp.barbaHooks = venueHooks;

export default CustomExp;
